import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const DisplaySettingsStyle = StyleSheet.create({
    container: {
        flex: 1
    },
    loader: {
        flex: 1, alignItems: 'center', justifyContent: 'center'
    },
    buttonView: {
        flexDirection: 'row', alignSelf: 'flex-end', marginTop: 15
    },
    buttonStyle: {
        width: 100, borderRadius: 7, borderWidth: 1, backgroundColor: appColors.light, borderColor: appColors.grey
    },
    saveButtonStyle: {
        width: 100, borderRadius: 7, backgroundColor: appColors.primary, borderWidth: 1, borderColor: appColors?.grey
    },
    buttonContainer: {
        paddingHorizontal: 15
    },
    textStyle: {
        marginTop: 10
    },
    titleStyle: {
        fontFamily: appFonts.bold, fontSize: fontSize.mediumFontSize
    },
    cardContainer: {
        borderRadius: 7, borderWidth: 0
    },
    cardView: {
        flexDirection: 'row', justifyContent: 'space-between'
    },
    subHeaderView: {
        marginTop: 10
    },
    inputView: {
        flex: 0.5
    },
    toolTipView: {
        marginLeft: 5, marginTop: 7
    },
    textView: {
        flexDirection: 'row'
    },
    checkboxTitle: {
        marginLeft: 0
    },
    labelStyle: {
        fontSize: fontSize.smallerFontSize,
        color: appColors.labelColor

    },
    inputStyle: {
        fontSize: fontSize.mediumFontSize, color: appColors.lightDark, fontFamily: appFonts.medium
    },
    inputContainerStyle: {
        borderColor: appColors.borderColor
    },
    errorStyle: {
        fontSize: fontSize.errorFontSize, fontFamily: appFonts.medium, marginLeft: -1, color: appColors.red
    },
    dropDownStyle: {
        borderWidth: 1,
        borderRadius: 5,
        borderColor: appColors?.lightGrey,
        marginTop: 5,
    },
    dropDownContainerStyle: {
        borderWidth: 1,
        borderColor: appColors?.lightGrey,
    },
    dropDownlabelStyle: {
        fontSize: fontSize.tinyFontSize, color: appColors?.dark, fontFamily: appFonts?.medium,
    },
    switchStyle: {
        marginTop: 5,
        transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }]
    },
    viewStyle: {
        flex: 1
    }
})